export default __webpack_public_path__ + "static/media/postIt.0f3b5030.svg";